<template>
    <a-row>
        <a-row type="flex" justify="start" class="routesTitle" align="middle">
            <a-col class="ml4">Deliveries</a-col>
        </a-row>
        <a-row style="border: 1px solid gray;padding:4px">
            <a-row type="flex" justify="space-between">
                <a-col>
                    <a-row  type="flex" justify="start" align="middle">
                        <a-popconfirm
                                :title="$t('pubGicSet.AreyoudeleTask')"
                                :okText="$t('pubGicSet.Yes')"
                                :cancelText="$t('pubGicSet.No')"
                                @confirm="delDeliveries"
                        >
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('roleGe.Delete') }}</span>
                                </template>
                                <img class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                            </a-tooltip>
                        </a-popconfirm>
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>Refresh</span>
                            </template>
                            <img class="sbxs mllr4" style='margin-top: 2px' src="../../../assets/img/ss-refresh.png" width="22" height="20" @click="init">
                        </a-tooltip>
                    </a-row>
                </a-col>
                <a-col>
                    <a-pagination
                            :pageSizeOptions="deliveries.pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${deliveries.pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="deliveries.pagingTotal"
                            v-model="deliveries.currentVal"
                            :pageSize.sync="deliveries.pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <a-row class="mt4">
                <a-row id="delDrop">
                    <vxe-table
                            stripe
                            resizable
                            border
                            show-header-overflow
                            show-overflow
                            highlight-hover-row
                            size="mini"
                            ref="deliveriesRefs"
                            @cell-dblclick="dbClickEdit"
                            :height="deliveriesHeight"
                            :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;"></span>
                        </template>
                        <vxe-table-column type="checkbox" width="40"></vxe-table-column>
                        <vxe-table-column field="doId" title=" Do No." width="130" sortable></vxe-table-column>
                        <vxe-table-column field="actionType" width="80" title="Type" sortable>
                            <template v-slot="{ row }">
                                {{ row.actionType | filterOrdetType}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="status" title="Status" width="80">
                            <template v-slot="{ row }">
                                {{ row.status | filterSatus}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="custRef1" title="Ref" width="100" sortable></vxe-table-column>
                        <vxe-table-column field="address" title="Address"></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-row>
        </a-row>
    </a-row>

</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import Sortable from "sortablejs";
    import { mapState } from "vuex";
    export default{
        computed: {
            ...mapState(["tmsDrag"]),
        },
        props:{
          deliveriesHeight: {
                type: Number,
                default: ()=>{
                    return 100
                }
            },
            wayUid: {
                type: String,
                default: ()=>{
                    return null
                }
            },
        },
        filters: {
            filterSatus(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.TMS_ROUTE_WAY_STATUS
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            },
            filterOrdetType(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.TMS_ORDER_TYPE
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            }
        },
        watch:{
            wayUid(v){
                if(v == null){
                    this.tableData = []
                    return
                }
                this.init()
            }
        },
        data(){
            return{
                tableData: [],
                deliveries: {
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal:0,
                    currentVal: 1,
                    pagingSize: 10
                }, // 分页
            }
        },
        created () {
            this.rowDrop()
        },
        beforeDestroy () {
            if (this.sortable) {
                this.sortable.destroy()
            }
        },
        methods:{
            //      分页
            onShowSizeChange(current, pageSize) {
                this.deliveries.currentVal = current;
                this.deliveries.pagingSize = pageSize;
                this.init()
            },
            //      分页
            tableChangePage(current) {
                this.wapPoints.currentVal = current;
                this.init()
            },
//            删除
            delDeliveries(){
                let len = this.$refs.deliveriesRefs.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    let flag = true
                    for(let i in len){
                        if(len[i].status !='00'){
                            let str = len[i].doId + ' status not allow delete'
                            this.$customMessage.warning(str);
                            flag = false
                        }
                        arr.push(len[i].uid)
                    }
                    if(!flag){return}
                    let params = {
                        uids:arr.toString()
                    }
                    if(this.tableData.length == len.length){
                        params.wayPointUid = this.wayUid
                    }
                    ajax.post(api.TMSDELETEROUTEDETAIL,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            //this.init()
                            this.$emit('emitDeliveriesUid','Orderinit')
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
            init(){
                this.tableData = []
                if(this.wayUid===null){
                    this.tableData = null;
                }else {
                    let params = {
                        uid:this.wayUid,
                        pageNumber:this.deliveries.currentVal,
                        pageSize: this.deliveries.pagingSize
                    }
                    ajax.get(api.TMSFINDDELIVERIES,params).then(res=>{
                        this.tableData = res.data
                        this.deliveries.pagingTotal = res.total
                        if(this.tableData.length > 0){
                            this.selectRow = this.tableData[0]
                        }else{
                            this.$emit('emitDeliveriesUid','Orderinit')
                        }
                    })
                }


            },
            // 双击 order 编辑框弹出
            dbClickEdit({row}){
              this.$emit('emitDeliveriesUid',row.doHeaderUid)
            },
//            拖拽
            rowDrop () {
                let that = this
                this.$nextTick(() => {
                    let ordersTableRef = this.$refs.deliveriesRefs
                    let delDrop = document.getElementById('delDrop')
                    //拖拽orders
                    this.sortable = Sortable.create(delDrop, {
                        handle: '.drag-btn',
                        group: {name:'od'},
                        sort: false,
                    })
                    /*this.sortable = Sortable.create(delDrop, {
                        handle: '.drag-btn',
                        group: {name:'od'},
                        sort: false,
                        onAdd: function (/!**Event*!/evt) {
                            setTimeout(()=>{
                                if(that.tmsDrag.wayId == null){
                                    that.$customMessage.warning('Please select wayPoints');
                                }else {
                                    ajax.post(api.TMSSAVETMSROUTEDETAIL,that.tmsDrag).then(res=>{
                                        if(res.code == 200){
                                            that.init();
                                            that.$emit('emitDelvs','init')
                                        }else{
                                            that.$customMessage.warning(res.msg);
                                            that.$emit('emitDelvs','order')
                                        }
                                    })
                                }


                            },1000)
                        },
                    })*/
                })
            }
        }
    }
</script>
<style>
    #delDrop>tr{
        display: none;
    }

</style>